import {DesignerVersion} from '@mintdata-wsp/common/state/ui/visualDesigner/DesignState';
import {BoxTypes} from '@mintdata-wsp/common/state/ui/visualDesigner/surface/component/Box';
import {IMigration} from '@mintdata-wsp/wsp/controllers/visualDesigner/designState/DesignMigrationController';
import {Assert} from '@mintdata/mint-kit/impl/util/Assert';
import {IdUtil} from '@mintdata/mint-kit/impl/util/IDUtil';

const MIGRATED_VERSION:DesignerVersion = 22;

interface IPageEventPropsSnapshots
{
	pageLoad:any,
	pageShown:any,
	pageHidden:any,
}

export const migration_21_22:IMigration = {
	from: MIGRATED_VERSION - 1,
	to: MIGRATED_VERSION,
	migrate: (designState:any) =>
	{
		Assert.yes(designState.designerVersion === MIGRATED_VERSION - 1);

		console.log(`migration ${MIGRATED_VERSION - 1}->${MIGRATED_VERSION} designState`, designState);

		if( designState.surface && designState.surface.pages )
		{
			Object.values(designState.surface.pages).forEach((page:any) =>
			{
				if( page.artboard && page.artboard.allBoxes )
				{
					Object.values(page.artboard.allBoxes).forEach((boxSnapshot:any) =>
					{
						const {id, boxType, componentDesc} = boxSnapshot;

						if( boxType === BoxTypes.Viewport )
						{
							let eventPropSnapshots:IPageEventPropsSnapshots = Object.values(componentDesc._eventProps)
								.reduce(
									(acc:any, eventPropSnapshot:any) =>
									{
										if( eventPropSnapshot.name === 'onPageLoad' )
											acc.pageLoad = eventPropSnapshot;

										if( eventPropSnapshot.name === 'onPageShown' )
											acc.pageShown = eventPropSnapshot;

										if( eventPropSnapshot.name === 'onPageHidden' )
											acc.pageHidden = eventPropSnapshot;

										return acc;
									},
									{
										pageLoad: null,
										pageShown: null,
										pageHidden: null,
									}
								);

							if( !eventPropSnapshots.pageShown )
							{
								eventPropSnapshots.pageShown = {
									id: eventPropSnapshots.pageLoad ? eventPropSnapshots.pageLoad.id : IdUtil.newGUID(),
									name: 'onPageShown',
									boxId: id,
									isEnabled: eventPropSnapshots.pageLoad ? eventPropSnapshots.pageLoad.isEnabled : false,
									bindingId: eventPropSnapshots.pageLoad ? eventPropSnapshots.pageLoad.bindingId : null,
								};

								if( eventPropSnapshots.pageShown.bindingId && designState.bindings
									&& designState.bindings[eventPropSnapshots.pageShown.bindingId]
								)
								{
									designState.bindings[eventPropSnapshots.pageShown.bindingId].eventPropName = 'onPageShown';
								}
							}

							if( !eventPropSnapshots.pageHidden )
							{
								eventPropSnapshots.pageHidden = {
									id: IdUtil.newGUID(),
									name: 'onPageHidden',
									boxId: id,
									isEnabled: false,
									bindingId: null,
								};
							}

							let eventProps:any = componentDesc._eventProps;

							if( eventPropSnapshots.pageLoad )
								delete eventProps[eventPropSnapshots.pageLoad.id];

							componentDesc._eventProps = {
								[eventPropSnapshots.pageShown.id]: eventPropSnapshots.pageShown,
								[eventPropSnapshots.pageHidden.id]: eventPropSnapshots.pageHidden,
								...eventProps
							};
						}
					});
				}
			});
		}

		designState.designerVersion = MIGRATED_VERSION;

		return designState;
	}
};
